import { useTheme } from '../../contexts/Theme';
import {
  BUTTON_VARIANTS,
  Divider,
  IconClose,
} from 'cdk-radial';
import { usePaneManagement } from '../../contexts/PaneManagementContext';
import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../constants';
import { TextButton } from '../Buttons/TextButton';
import { Button } from '../Buttons/Button';
import { useAdoptEaseStore } from '../../Store/useAdoptEaseStore'
import * as Styles from './styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const customFooter = (props: { onClose: Function, name: string, cdkUUrl: string, id: string }, hasTraining: Boolean) => () => {
  const { darkMode } = useTheme();
  const { trackEvent } = useAnalytics();
  const { openPane, openCdkuPane } = usePaneManagement();
  const {t} = useTranslation();

  const onCdkuOpen = (cdkUUrl: string) => {
    openCdkuPane('CDKU', cdkUUrl);
  };

  return (
    <Styles.StyledAllButtonDiv>
      <TextButton style={{ color: "#196FE1", fontSize: "14px", fontWeight: "550", minWidth: "110px", maxWidth: "110px", left: "10px", position:'absolute' }} darkMode={darkMode}
        text={t('adoptease.cancel')}
        data-testid='cancel-button'
        onClick={() => {
          trackEvent(AMPLITUDE_EVENTS.ADOPTEASE_APPLICATION_MODAL_CANCEL, {
            'Application': props.name
          });
          props.onClose();
        }} />
      <Styles.StyledButtonDiv>

        <Button style={{ backgroundColor: '#E8F1FC', color: '#155EBF', fontSize: "14px", fontWeight: "500", marginBottom: "10px", marginRight: "10px", display: "grid" }} darkMode={darkMode}
          variant={BUTTON_VARIANTS.PRIMARY} text={`${t('adoptease.open')}  ${props.name}`}
          onClick={() => {
            props.onClose();
            trackEvent(AMPLITUDE_EVENTS.OPEN_APPLICATION_FROM_ADOPTEASE, {
              'Application': props.name
            });
             trackEvent(AMPLITUDE_EVENTS.OPEN_APPLICATION, {
                  Application: props.name,
                });
            openPane(props.id);

            //Adding to opened apps in local storage for AdoptEase
            const openedApps = JSON.parse(localStorage.getItem('opened-apps') || '[]');
            if (!openedApps.includes(props.id)) {
              openedApps.push(props.id);
              localStorage.setItem('opened-apps', JSON.stringify(openedApps));
            }
          }
          } />
        {!hasTraining && props.cdkUUrl && props.cdkUUrl !== "" &&
          <Button style={{ backgroundColor: '#196FE1', fontSize: "14px", fontWeight: "500",  }} darkMode={darkMode} variant={BUTTON_VARIANTS.PRIMARY}
            text={`${t('adoptease.take')}`}
            onClick={() => {
              trackEvent(AMPLITUDE_EVENTS.OPEN_APPLICATION_TRAINING_FROM_ADOPTEASE, {
                'Application': props.name
              });
              onCdkuOpen(props.cdkUUrl);
              props.onClose();
            }
            } />}
      </Styles.StyledButtonDiv>

    </Styles.StyledAllButtonDiv>)
}

const AdoptEaseApplicationDialog = (props: {
  isOpen: boolean,
  onClose: Function,
  iconColor: string,
  iconText: string,
  name: string,
  description: string,
  cdkUUrl: string,
  id: string,
}): JSX.Element => {

  const { trackEvent } = useAnalytics(); 
  const {t} = useTranslation();

  const neverUsedApps = useAdoptEaseStore((state: any) => state.neverUsedApps);
  const adoptEaseConfigData = useAdoptEaseStore((state: any) => state.adoptEaseConfigData);
  const [hasTraining, setHasTraining] = useState(false);
  const [message, setMessage] = useState('');
  const [trainingMessage, setTrainingMessage] = useState('');
  const userLocale = localStorage.getItem('userLocale');

     useEffect(() => {
      try{
        const locale = userLocale?.replace('_', '') || 'enUS';
        const courseTaken = neverUsedApps.find((app: any) => app.appId === props.id).courseTaken;
        setHasTraining(courseTaken);
        const config = adoptEaseConfigData.find((config: any) => config.appId === props.id);
        setMessage(config.message[locale]);
        setTrainingMessage(config.messageTraining[locale]);
        } catch (e) {
        console.error('AdoptEase', e);
      }
  }, [adoptEaseConfigData, neverUsedApps, props.id, props.cdkUUrl, userLocale]);

  return (
    <div>
      <Styles.StyledApplicationDialog
        isOpen={props.isOpen}
        id="recomm-dialog"
        data-testid="adoptease-recomm-dialog-is"
        onClose={props.onClose}
        hideHeader
        renderCustomFooterComponent={customFooter(props, hasTraining)}
        hideCloseButton={true}
        disableOverlayClicked={true}
      >
        <Styles.StyledDiv style={{
          padding: '10px 16px 16px 5px',
          justifyContent: 'space-between',
          height: '70px'
        }}>
          <Styles.CardHeader>
            <Styles.ProductIcon iconColor={props.iconColor} data-testid="app-icon">
              {props.iconText || ''}
            </Styles.ProductIcon>
            <div style={{ paddingLeft: '10px' }}>
              <Styles.CardTitle>
                {props.name}
              </Styles.CardTitle>
              <div style={{ fontWeight: '400' }}>CDK Global</div>
            </div>
          </Styles.CardHeader>
          <Styles.RoundedIconButton
            data-testid="on-close-icon"
            size="small"
            icon={<IconClose />}
            onClick={() => {
              trackEvent(AMPLITUDE_EVENTS.ADOPTEASE_APPLICATION_MODAL_CANCEL, {
                'Application': props.name
              }); props.onClose();
            }}
            text="BannerClose"
          />
        </Styles.StyledDiv>
        <Divider data-testid="header-divider" />

        <div style={{ paddingTop: '15px', fontSize: "20px", fontWeight: "500" }} >{`${props.name}  ${t('adoptease.appAvailable')}`}</div>
        {!hasTraining && props.cdkUUrl && props.cdkUUrl !== ""?
          <div style={{ paddingTop: '5px', fontSize: "16px", fontWeight: "350" }} data-testid="no-usage-no-training">{message}</div>
          :
          <div style={{ paddingTop: '5px', fontSize: "16px", fontWeight: "350" }} data-testid="no-usage">{trainingMessage}</div>
          }
        <div>
        </div>
      </Styles.StyledApplicationDialog>
    </div>
  );
};
export default AdoptEaseApplicationDialog;
